module.exports = __webpack_public_path__ + "assets/img/box1-2.501a0829.svg";